export default __webpack_public_path__ + "static/media/ic-open-conversations.7acd4e0c.svg";